import React from "react";
import { FeatureRequestListItem } from "interfaces/feature-request";
import styled from "styled-components";
import moment from "moment";

const ShortValue = styled.div`
    font-size: 14px;
    font-weight: 400;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const TagValue = styled.div`
    border-radius: 12px;
    background-color: #f2f2f2;
    border: 1px solid #b3b3b3;
    display: inline-block;
    padding: 1px 12px;
    font-size: 14px;
    font-weight: 400;

    &:not(:last-child) {
        margin-right: 0.5rem;
    }
`;

const shortValueColumns = ["description", "createdAt", "updatedAt"];
const tagValueColumns = ["state", "businessArea"];

const columnValueFormatters = {
    createdAt: (value: string): string => (value ? moment(value).format("D.M.YYYY") : ""),
    updatedAt: (value: string): string => (value ? moment(value).format("D.M.YYYY") : ""),
    businessArea: (value: string): string[] => value.split(",").map((tag: string) => tag.trim()),
};

const getValue = (item: FeatureRequestListItem, valueType: string) => {
    const value = item[valueType as keyof FeatureRequestListItem];
    const valueFormatter = columnValueFormatters[valueType as keyof typeof columnValueFormatters];

    return value && valueFormatter ? valueFormatter(value) : value;
};

const FeatureRequestTableRow: React.FC<{
    item: FeatureRequestListItem;
    valueType: string;
}> = ({ item, valueType }) => {
    const value = getValue(item, valueType);

    if (value && shortValueColumns.includes(valueType)) {
        return <ShortValue>{value}</ShortValue>;
    } else if (value && tagValueColumns.includes(valueType)) {
        return Array.isArray(value) ? (
            <>
                {value.map((tag, index) => (
                    <TagValue key={index}>{tag}</TagValue>
                ))}
            </>
        ) : (
            <TagValue>{value}</TagValue>
        );
    }

    return <div>{value}</div>;
};

export default FeatureRequestTableRow;
